import {
    IconChevronLeftRegular,
    NavigationBar,
    skinVars,
    Text2,
    ThemeVariant,
    useWindowSize,
} from '@telefonica/mistica';
import { useNavigate } from 'react-router-dom';
import { isWebviewAndroid, isWebviewIOS } from '../../utils/navigation/controlDevices';
import { t } from 'i18next';
import { getRoleLine } from '../../utils/dataTransformation/productConsumption';
import './index.scss';
import BreadCrumbsWrapper from '../BreadcrumbsWrapper';
import { useConfigureLineContext } from '../../utils/store/context/configure-line-context/ConfigureLineContext';
import { getSIMSInfo } from '../../services/ConfigureLineService';
import { useQuery } from '@tanstack/react-query';

export const HeaderConfigureLine = () => {
    const size = useWindowSize();
    const navigate = useNavigate();
    const { isConvergent } = useConfigureLineContext();
    const consumptions = JSON.stringify(window.localStorage.getItem('storages'));
    const { lineActive } = useConfigureLineContext();
    const { data: infoSIM } = useQuery(['sims-info'], () => (lineActive ? getSIMSInfo(lineActive) : null), {
        enabled: !!lineActive,
    });

    return (
        <div
            className='header-configureLine-component'
            style={{ background: size.width >= 1024 ? skinVars.colors.backgroundBrand : '' }}
        >
            {!(isWebviewAndroid || isWebviewIOS) && (
                <>
                    <div className='header-configureLine-component__navigationBar'>
                        <NavigationBar
                            isInverse={true}
                            onBack={() => {
                                navigate(`/configure-line`);
                            }}
                            title={t('lineManagement')}
                        />
                    </div>
                    <div
                        className='header-configureLine-component__return'
                        onClick={() => {
                            navigate(`/configure-line`);
                        }}
                    >
                        <div className='header-configureLine-component__return-icon'>
                            <IconChevronLeftRegular color={skinVars.colors.appBarBackground} size={20} />
                        </div>
                        <Text2 medium color={skinVars.colors.appBarBackground}>
                            {t('returnResponsive')}
                        </Text2>
                    </div>
                </>
            )}
            <div className='header-configureLine-component__breadcrumbs'>
                <ThemeVariant isInverse>
                    <BreadCrumbsWrapper
                        title={t('configESIMTitle')}
                        breadcrumbs={
                            !isConvergent
                                ? [
                                      { title: t('breadcrumbsHome'), url: '/home' },
                                      {
                                          title: t('lineManagement'),
                                          url: `/configure-line`,
                                      },
                                  ]
                                : [
                                      { title: t('breadcrumbsHome'), url: '/home' },
                                      {
                                          title: getRoleLine(JSON.parse(consumptions), infoSIM?.productPsId!),
                                          url: `/mobile?productPsId=${infoSIM?.productPsId}`,
                                      },
                                      {
                                          title: t('lineManagement'),
                                          url: `/configure-line`,
                                      },
                                  ]
                        }
                    />
                </ThemeVariant>
            </div>
        </div>
    );
};
